exports.APPLICATION_STATUSES = ["interview", "processing", "processing_interview", "refuse", "accept", "offer", "offer_fixed_rate", "tech_not_interested"];

exports.TECH_LEVELS = ["tier 1", "tier 2", "tier 3", "system admin", "IT director", "security", "network admin"];

exports.PANEL_TYPES = {
  ADD: "add",
  EDIT: "edit"
}
